<template>
    <span 
        :id="localUniqueId"
        class="border rounded-pill font-weight-500 text-uppercase text-nowrap"
        :class="bgClass"
        style="padding: 2px 5px; cursor: default;"
        :style="outerStyles"
        v-b-tooltip.hover
        :title="tooltip"
    >
        <!-- <b-iconstack font-scale="1">
            <b-icon icon="circle-fill" scale="1.5" variant="primary-200"></b-icon>
            <b-icon icon="circle-fill" animation="throb" scale="0.7" variant="primary"></b-icon>
        </b-iconstack> -->
        <b-icon 
            v-if="!noIcon"
            icon="circle-fill" 
            animation="throb" 
            scale="1" 
            :variant="iconVariant" 
            :style="iconStyles"
        ></b-icon>
        {{ text }}
    </span>
</template>

<script>
import { nanoid } from 'nanoid';

export default {
    name: 'ActiveAssigneeChip',
    components: {},
    mixins: [],
    props: {
        variant: {
            type: String,
            default: 'primary',
        },
        text: {
            type: String,
            default: '',
        },
        tooltip: {
            type: String,
            default: 'Active Tasks Pending',
        },
        fontSize: {
            type: String,
            default: '12px',
        },
        fontWeight: {
            type: String,
            default: '500', 
        },
        noIcon: {
            type: Boolean,
            default: false,  // if true, no icon will be shown
        },
    },
    data() {
        return {
            localUniqueId: `active-assignee-chip-${nanoid(10)}`,
        }
    },
    computed: {
        bgClass() {
            return `bg-${this.variant}-100`;
        },
        iconVariant() {
            return `${this.variant}-600`;
        },
        outerStyles() {
            return {
                fontSize: this.fontSize,
                fontWeight: this.fontWeight,
            };
        },
        iconStyles() {
            return {
                marginRight: this.text ? '2px' : '0',
            };
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
}
</script>

<style lang="scss" scoped>
</style>